/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { RuoloAccessoInputDtoToJSON, RuoloAccessoOutputDtoFromJSON, UtenteRuoloAccessoInputDtoToJSON, UtenteRuoloAccessoOutputDtoFromJSON, } from '../models/index';
/**
 *
 */
export class ControllerPerLaGestioneDeiRuoliDiAccessoEDelleAssociazioniUtenteRuoloApi extends runtime.BaseAPI {
    /**
     * Consente di eliminare un ruolo di accesso tramite il suo id
     * Elimina un ruolo di accesso
     */
    deleteRuoloAccessoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteRuoloAccesso().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Consente di eliminare un ruolo di accesso tramite il suo id
     * Elimina un ruolo di accesso
     */
    deleteRuoloAccesso(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteRuoloAccessoRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Consente di eliminare un\'associazione utente-ruolo di accesso tramite il suo id
     * Elimina un\'associazione utente-ruolo
     */
    deleteUtenteRuoloAccessoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteUtenteRuoloAccesso().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso/utente/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Consente di eliminare un\'associazione utente-ruolo di accesso tramite il suo id
     * Elimina un\'associazione utente-ruolo
     */
    deleteUtenteRuoloAccesso(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteUtenteRuoloAccessoRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Restituisce l\'elenco completo dei ruoli di accesso
     * Elenco ruoli di accesso
     */
    getAllRuoloAccessoRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RuoloAccessoOutputDtoFromJSON));
        });
    }
    /**
     * Restituisce l\'elenco completo dei ruoli di accesso
     * Elenco ruoli di accesso
     */
    getAllRuoloAccesso(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllRuoloAccessoRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce l\'elenco completo delle associazioni tra utenti e ruoli di accesso
     * Elenco associazioni utente-ruolo
     */
    getAllUtenteRuoloAccessoRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso/utente`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UtenteRuoloAccessoOutputDtoFromJSON));
        });
    }
    /**
     * Restituisce l\'elenco completo delle associazioni tra utenti e ruoli di accesso
     * Elenco associazioni utente-ruolo
     */
    getAllUtenteRuoloAccesso(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllUtenteRuoloAccessoRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce il ruolo di accesso identificato dall\'id
     * Dettaglio ruolo di accesso
     */
    getRuoloAccessoByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getRuoloAccessoById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RuoloAccessoOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce il ruolo di accesso identificato dall\'id
     * Dettaglio ruolo di accesso
     */
    getRuoloAccessoById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRuoloAccessoByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce l\'associazione utente-ruolo di accesso identificata dall\'id
     * Dettaglio associazione utente-ruolo
     */
    getUtenteRuoloAccessoByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getUtenteRuoloAccessoById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso/utente/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UtenteRuoloAccessoOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce l\'associazione utente-ruolo di accesso identificata dall\'id
     * Dettaglio associazione utente-ruolo
     */
    getUtenteRuoloAccessoById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUtenteRuoloAccessoByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO arriva senza id valido esistente viene creato un nuovo ruolo di accesso; se l\'id è già presente viene aggiornato il record esistente.
     * Crea o aggiorna un ruolo di accesso
     */
    saveRuoloAccessoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['ruoloAccessoInputDto'] == null) {
                throw new runtime.RequiredError('ruoloAccessoInputDto', 'Required parameter "ruoloAccessoInputDto" was null or undefined when calling saveRuoloAccesso().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RuoloAccessoInputDtoToJSON(requestParameters['ruoloAccessoInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RuoloAccessoOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO arriva senza id valido esistente viene creato un nuovo ruolo di accesso; se l\'id è già presente viene aggiornato il record esistente.
     * Crea o aggiorna un ruolo di accesso
     */
    saveRuoloAccesso(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveRuoloAccessoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO arriva senza id valido esistente viene creata una nuova associazione; se l\'id è già presente viene aggiornato il record esistente.
     * Crea o aggiorna un\'associazione utente-ruolo
     */
    saveUtenteRuoloAccessoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['utenteRuoloAccessoInputDto'] == null) {
                throw new runtime.RequiredError('utenteRuoloAccessoInputDto', 'Required parameter "utenteRuoloAccessoInputDto" was null or undefined when calling saveUtenteRuoloAccesso().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/ruolo-accesso/utente`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UtenteRuoloAccessoInputDtoToJSON(requestParameters['utenteRuoloAccessoInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UtenteRuoloAccessoOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO arriva senza id valido esistente viene creata una nuova associazione; se l\'id è già presente viene aggiornato il record esistente.
     * Crea o aggiorna un\'associazione utente-ruolo
     */
    saveUtenteRuoloAccesso(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveUtenteRuoloAccessoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
